import { ResponseMESF } from "@dexteel/mesf-core";
import { ButtonGroup, IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { GetApp as GetAppIcon } from "@mui/icons-material";
import { useState } from "react";
import { ConfirmationDialogRaw } from "../../../../../../controls/modals/ConfirmationDialogRaw";
import { useTimerContext } from "../../../context/timer.provider";

interface Props {
  onEdit: (itemId: number) => void;
  readFromPLC?: (value?: string) => Promise<ResponseMESF>;
  id: number;
  heatStatusCode: string;
}

export const EditAndPLCButtons = ({
  onEdit,
  readFromPLC,
  id,
  heatStatusCode,
}: Props) => {
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
  const { pause, resume } = useTimerContext();

  return (
    <>
      <ButtonGroup>
        {heatStatusCode !== "F" && (
          <IconButton
            color="primary"
            onClick={() => {
              onEdit(id);
            }}
            title="Edit"
          >
            <EditIcon style={{ cursor: "pointer" }} fontSize="small" />
          </IconButton>
        )}

        {readFromPLC && (
          <IconButton
            color="primary"
            onClick={() => {
              pause();
              setOpenConfirmModal(true);
            }}
            title="Get from PLC"
          >
            <GetAppIcon style={{ cursor: "pointer" }} fontSize="small" />
          </IconButton>
        )}
      </ButtonGroup>

      <ConfirmationDialogRaw
        title="Confirmation"
        message={
          "Are you sure you want to download data from the PLC? This will override any manual changes."
        }
        open={openConfirmModal}
        onClose={(value) => {
          setOpenConfirmModal(false);
          if (readFromPLC) {
            readFromPLC(value);
          }
          resume();
        }}
      />
    </>
  );
};
